import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
// import '../styles/timelinelist.scss';
//import $ from 'jquery';

import {convertXMLDoc} from './utils'

///TODO: Note this is very similar to the Text component
//it would be nice if this could be refactored to be a more generic component that could handle both
//however, the edition text will

//TODO: article componet needs to retrieve and article type and then pick a different style sheet for different types.

interface MyComponentProps {
  resourceid: string;
  info?: any;
}

export const Article: React.FC<MyComponentProps> = (props) => {

  useEffect(() => {
    // console.log("Article props", props)
    // console.log("Article props info", props.info)
    retrieveText(props.info.articleDoc, props.info.articleType)
  }, [props])

  const retrieveText = (doc:string, articleType: string) => {
    if (doc){
      let xmlurl = ""
      if (doc.includes("ipfs") || (doc.includes("zotero"))){
         xmlurl = doc
       }
       else{
        const docFragment = doc.split("/master/")[1].split("/")[1]
         xmlurl = "https://exist.scta.info/exist/apps/scta-app/text/scta-articles/" + docFragment
       }
      let xslurl = ""
      if (articleType === "http://scta.info/resource/timeline"){
         xslurl = "/xslt/articles/timeline.xsl"
      }
      else if (articleType === "http://scta.info/resource/bibliography"){
        xslurl = "/xslt/articles/bibliography.xsl"
      }
      else if (articleType === "http://scta.info/resource/biography"){
        xslurl = "/xslt/articles/biography.xsl"
      }
      else{
        xslurl = "/xslt/articles/standard.xsl"
      }
    
      //conversion done in promise in utils.js file
      const resultDocument = convertXMLDoc(xmlurl, xslurl)
      resultDocument.then((data: any) => {
        //appendage to file
        //and event binding
        //happens inside promise call back
        console.log("data", data)
        // ...existing code...
        const textElem = document.getElementById("text");
        if (textElem) {
          textElem.innerHTML = "";
          textElem.appendChild(data);
        }

      })
    }
  }
    

  return (
    <Container>
      <div id="text">
        <p>{props.info.articleDoc}</p>
        <p>{props.info.articleType}</p>
        <p>{props.resourceid}</p>
        <p>{props.info.resourceTitle}</p>
      </div>

    </Container>
  );
}
